import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { store } from "../../store/store";
const baseUrl = process.env.REACT_APP_base_URL;

const updateSolutionStatusApi = createApi({
    reducerPath: 'updateSolutionStatusApi',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers) => {
            // const token = useSelector((state)=> state.user.token)
            const token = store.getState().user.token;
            if (token) {
              headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        updateSolutionStatus: builder.mutation({
            query: ({ id, status, userId , boardId }) => ({
                url: `solution_requirements/${id}`,
                method: 'PUT',
                body: { 
                solution_status: status,
                user_id:userId, 
                board_id: boardId
                },
            }),
            transformResponse: (response) => {
                const savedData = response.data;
                return {
                    id: savedData._id,
                    solutionId: savedData.solution_id,
                    boardId: savedData.board_id,
                    solutionStatus: savedData.solution_status,
                    solutionName: savedData.solution_name,
                    techName: savedData.tech_name,
                    industryName: savedData.industry_name,
                    useCaseName: savedData.usecase_name,
                    useCaseId: savedData.use_case_id,
                    dateAdded: savedData.date_added,
                    updatedAt: savedData.updated_at,
                };
            },
            // These properties should be part of the mutation, not the query
            refetchOnWindowFocus: true,
            retry: true,
            onError: (error) => {
                console.error('Fetch user details error:', error);
                // Handle error cases as per your application's requirements
            },
        }),
    }),
});

export const { useUpdateSolutionStatusMutation } = updateSolutionStatusApi;
export default updateSolutionStatusApi;
